import { jsx, jsxs } from "react/jsx-runtime";
import QuestionMarkCircle from "@crehana/compass.icons.fill/QuestionMarkCircle";
import { clsx } from "clsx";
import { Tooltip } from "../../../Tooltip/index.js";
const Label = ({ label, tooltip, size = 'sm', state })=>/*#__PURE__*/ jsxs("div", {
        className: clsx('tw-flex tw-items-center tw-gap-0.8', 'sm' === size ? 'tw-font-subtitle5' : 'tw-font-subtitle4', 'disabled' === state ? 'dark:tw-text-neutral-dark-600' : 'dark:tw-text-neutral-light-100'),
        children: [
            /*#__PURE__*/ jsx("span", {
                children: label
            }),
            tooltip && /*#__PURE__*/ jsx(Tooltip, {
                type: "small",
                label: tooltip,
                position: "top",
                children: /*#__PURE__*/ jsx("div", {
                    children: /*#__PURE__*/ jsx(QuestionMarkCircle, {
                        size: 16,
                        className: clsx('tw-text-neutral-light-600 tw-flex tw-items-center', 'disabled' === state && 'dark:tw-text-neutral-dark-600')
                    })
                })
            })
        ]
    });
const components_Label = Label;
export default components_Label;
